let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i9F0Q")).then(() => parcelRequire('70jAs'));